import React, { useState } from "react";
import { Row, Col, Typography, Card, Space, Image } from "antd";
import LazyLoad from "react-lazyload";
import ImageBox from "components/ImageBox";
import { BsBookmark } from "react-icons/bs";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
import { ProductDetailsModalEditMode } from "components/ProductDetailsModal";

const { Title, Text } = Typography;

export default function ProductsCard({ item, index }) {
  const [showModal, setShowModal] = useState(false);

  
  return (
    <>
      {showModal && (
        <ProductDetailsModalEditMode
          showModal={showModal}
          setShowModal={setShowModal}
          id={item?.id}
        />
      )}
      <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
        {/* <LazyLoad height={200} offset={100}> */}
        <Card
          key={item?.secondary_category_id?.id}
          className="product-card"
          cover={
            <ImageBox
              imgUrl={
                item && item.product_images[0]
                  ? `${process.env.REACT_APP_CLOUDINARY}/c_lpad,h_214,q_100,w_283/${item?.product_images[0]?.directus_files_id}`
                  : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
              }
              fallbackUrl={
                item && item.product_images[0]
                  ? `${process.env.REACT_APP_DIRECTUS}assets/${item?.product_images[0]?.directus_files_id}?transforms=[["resize",{"width":283,"height":214,"fit":"contain","background":"white"}]]`
                  : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
              }
              alt={"product name"}
              onClick={() => {
                setShowModal(true);
                // gaEvent(GA.EVENT.CLICK, GA.CATEGORY.MASTER_CATALOGUE, GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_CARD, item?.product_id);
              }}
              shimmerStyles={{
                height: 222,
                borderTopLeftRadius: "0.5rem",
                borderTopRightRadius: "0.5rem",
              }}
            />
          }
        >
        {item?.is_exclusive_product?  <span
            style={{
              background: "rgba(66, 135, 245)",

              top: 0,
              right: 0,
              margin: "1rem",
              position: "absolute",
              borderRadius: "2rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
              width: "7rem",
              padding:"0.2em"
            }}
          >
            <Text
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "white",
                fontStyle: "normal",
              }}
            >
              Exclusive
            </Text>
          </span>:null}

          <Row>
            <Title className="product-id" type="secondary" level={5}>
              ID : {item?.product_id ? item?.product_id : "No product id"}
            </Title>
          </Row>

          {/* <Row>
            <Space direction="horizontal">
              <Title className="product-price" style={{ fontFamily: "Gilroy" }}>
                {item?.price ? item.currency + " " + item?.price : ""}
              </Title>
              <Text type="secondary" style={{ padding: "0.35rem" }}>
                {item?.price ? item?.quantity : " "}
              </Text>

            </Space>
          </Row> */}
        </Card>
        {/* </LazyLoad> */}
      </Col>
    </>
  );
}
